import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-actions" }

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import BanUserDialog from './BanUserDialog.vue';
import GrantGroupDialog from './GrantGroupDialog.vue';
import RevokeGroupDialog from './RevokeGroupDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAdminActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;
const banOpen = ref(false);
const grantOpen = ref(false);
const revokeOpen = ref(false);

const userId = (): string => props.detail.id;

async function unban(): Promise<void> {
    if (!confirm('Разблокировать пользователя?')) return;
    await request({ method: 'post', url: `/admin-api/users/${userId()}/unban/`, data: {} });
    onDone();
}

async function resetPassword(): Promise<void> {
    if (!confirm('Отправить письмо для сброса пароля?')) return;
    await request({ method: 'post', url: `/admin-api/users/${userId()}/reset-password/`, data: {} });
    alert('Письмо отправлено.');
}

async function forceLogout(): Promise<void> {
    if (!confirm('Отозвать все сессии пользователя?')) return;
    await request({ method: 'post', url: `/admin-api/users/${userId()}/force-logout/`, data: {} });
    alert('Сессии отозваны.');
}

function onDone(): void {
    banOpen.value = false;
    grantOpen.value = false;
    revokeOpen.value = false;
    // Simple v1 — reload to see updated state.
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (banOpen.value = true))
    }, "Заблокировать"),
    _createElementVNode("button", {
      class: "btn",
      onClick: unban
    }, "Разблокировать"),
    _createElementVNode("button", {
      class: "btn",
      onClick: resetPassword
    }, "Сбросить пароль"),
    _createElementVNode("button", {
      class: "btn",
      onClick: forceLogout
    }, "Force logout"),
    _createElementVNode("button", {
      class: "btn btn--primary",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (grantOpen.value = true))
    }, "Дать admin-группу"),
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (revokeOpen.value = true))
    }, "Убрать admin-группу"),
    (banOpen.value)
      ? (_openBlock(), _createBlock(BanUserDialog, {
          key: 0,
          open: banOpen.value,
          "user-id": userId,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (banOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (grantOpen.value)
      ? (_openBlock(), _createBlock(GrantGroupDialog, {
          key: 1,
          open: grantOpen.value,
          "user-id": userId,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (grantOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (revokeOpen.value)
      ? (_openBlock(), _createBlock(RevokeGroupDialog, {
          key: 2,
          open: revokeOpen.value,
          "user-id": userId,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (revokeOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true)
  ]))
}
}

})